export { default as MessagesView } from './MessagesView'



// WEBPACK FOOTER //
// ./src/views/Messages/index.tsx